import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import Strings from '../../../../i18n';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import { EditSerialNumberSideBarProps } from './editSerialNumberProps';
import { partNumberAction } from '../../../../utils/validators';
import { useDeleteSerialNumberMutation } from '../../../../services/manufacture/manufactureService';

export const EditSerialNumberSideBar = ({
  serialNumber,
  reloadTable,
  setOpenSideBar,
  setUsersSelected
}: EditSerialNumberSideBarProps) => {
  const [deleteSerialNumber, { isSuccess: isSuccessDelete }] =
    useDeleteSerialNumberMutation();

  const deleteSerialNumberAction = () => {
    if (serialNumber?.id) {
      deleteSerialNumber(serialNumber.id);
    }
  };

  useEffect(() => {
    if (isSuccessDelete) {
      toast.success('Data was deleted successfully');
      reloadTable();
      setOpenSideBar(false);
      setUsersSelected([]);
    }
  }, [isSuccessDelete]);

  return (
    serialNumber && (
      <Formik
        enableReinitialize
        validationSchema={partNumberAction}
        initialValues={{}}
        onSubmit={(values) => {}}
      >
        {() => (
          <>
            <StyledContainerItems>
              <StyledTitleSideBar>
                {Strings.manufacture.serialNumber.title}
              </StyledTitleSideBar>
              <SideBarDeleteActionWithPopup
                onDelete={() => deleteSerialNumberAction()}
                titleConfirmation={
                  Strings.manufacture.partNumber.create.deleteUserTitle
                }
                textConfirmation={Strings.common.thisActionIsIrreversible}
                textIcon={
                  Strings.manufacture.serialNumber.create.deleteSerialLabel
                }
              />
            </StyledContainerItems>
            <StyledContainerFooterSideBar>
              <button
                type="button"
                className="btn-cancel"
                onClick={() => {
                  setOpenSideBar(false);
                  setUsersSelected([]);
                }}
              >
                {Strings.common.cancel}
              </button>
            </StyledContainerFooterSideBar>
          </>
        )}
      </Formik>
    )
  );
};
